/* global
APP_NAME,
COMMIT_VERSION,
DEPLOY_TARGET,
NODE_ENV,
 */

/*
 * This module should stay top level and not import from the app,
 * as these constants are used by other top-level modules. For example
 * by the top-level Sentry integration.
 */
const DEVELOPMENT = "development";
const PRODUCTION = "production";
const STAGING = "staging";
const ENVS = {
  DEVELOPMENT,
  PRODUCTION,
  STAGING,
};

function getFleetUrl() {
  switch (DEPLOY_TARGET) {
    case ENVS.DEVELOPMENT:
      return "https://lfleet.cortexpowered.com";
    case ENVS.STAGING:
      return "https://sfleet.cortexpowered.com";
    default:
      return "https://fleet.cortexpowered.com";
  }
}
const FLEET_URL = getFleetUrl();

const ENV = {
  APP_NAME,
  COMMIT_VERSION,
  // This specifies the deployment environment: staging, production.
  DEPLOY_TARGET,
  FLEET_URL,
  // The builds are always "production" builds.
  NODE_ENV,
};

const BG_COLORS = [
  "aqua",
  "black",
  "blue",
  "fuchsia",
  "gray",
  "gray-light",
  "green",
  "light-blue",
  "lime",
  "maroon",
  "navy",
  "olive",
  "orange",
  "purple",
  "red",
  "teal",
  "yellow",
];

const BG_COLORS_ACTIVE = BG_COLORS.map((bc) => `${bc}-active`);

const TEXT_COLORS = [
  "aqua",
  "black",
  "blue",
  "fuchsia",
  "gray",
  "green",
  "light-blue",
  "lime",
  "maroon",
  "navy",
  "olive",
  "orange",
  "purple",
  "red",
  "teal",
  "yellow",
];

const PRIMARY_1 = ["#c3dbee", "#3c8dbc"];
const PRIMARY_2 = ["#eec3c5", "#bc3c4d"];
const PRIMARY_3 = ["#c3eed6", "#3cbc6b"];
const PRIMARY_4 = ["#eed6c3", "#bc6b3c"];
const PRIMARY_GREY = ["#d7d7d7", "#828282"];

const AUTH_LOGOUT_DOMAIN = ".cortexpowered.com";

const DEBOUNCE_INPUT_MS = 1000;
const DEFAULT_PAGE_SIZE = 10;
const NOOP = "app::NOOP";
const QS_ORDER_ASC = "";
const QS_ORDER_DESC = "-";

// Indicate a cancelled request.
const STATUS_CODE_CANCEL = -1;

// Regex for validating the URL
const URL_PATTERN = /^https?:\/\/[A-Za-z0-9-._~:/?#[\]@!$&'()*+,;=%]+$/;

const KILOBYTE = 1024;
const MEGABYTE = 1024 * 1024;

// While the standard mimetype for csv is text/csv, these could also
// be valid csv files, depending on how the csv was created. This is not an
// complete list as none exist.
const POSSIBLE_CSV_MIMETYPES = [
  "application/csv",
  "application/vnd.ms-excel",
  "application/vnd.msexcel",
  "application/x-csv",
  "text/anytext",
  "text/comma-separated-values",
  "text/csv",
  "text/plain",
  "text/tab-separated-values",
  "text/x-csv",
  "text/x-comma-separated-values",
];

const USER_RE = {
  SYSTEM: /cortexsystem\+\d+@vistarmedia\.com/,
  VISTAR: /.+@vistarmedia\.com/,
};

const ROLE = {
  ADMIN: "W",
  ADMIN_OPERATOR: "A",
  DISABLED: "D",
  OPERATOR: "O",
  READ_ONLY: "R",
  SUB_ACCOUNT: "S",
  UNKNOWN: "U",
};

export {
  AUTH_LOGOUT_DOMAIN,
  BG_COLORS,
  BG_COLORS_ACTIVE,
  DEBOUNCE_INPUT_MS,
  DEFAULT_PAGE_SIZE,
  ENV,
  ENVS,
  KILOBYTE,
  MEGABYTE,
  NOOP,
  POSSIBLE_CSV_MIMETYPES,
  PRIMARY_1,
  PRIMARY_2,
  PRIMARY_3,
  PRIMARY_4,
  PRIMARY_GREY,
  QS_ORDER_ASC,
  QS_ORDER_DESC,
  ROLE,
  STATUS_CODE_CANCEL,
  TEXT_COLORS,
  URL_PATTERN,
  USER_RE,
};
